import React from "react";
import {Button as AntdButton} from "antd";
import classes from "./RoundedButton.module.scss";

const RoundedButton = ({
                           className = "",
                           type,
                           htmlType = 'button',
                           disabled,
                           onClick,
                           isWhite = false,
                           loading = false,
    children
                       }) => {
    return <AntdButton type={type}
                       htmlType={htmlType}
                       loading={loading}
                       className={`${className} ${isWhite && classes.btnWhite} button`}
                       disabled={disabled}
                       onClick={onClick}
    >
        {children}
    </AntdButton>
}

export default RoundedButton;